// user positions in a school class
export const CLASS_POSITION = {
  STUDENT: 'STUDENT',
  TEACHER: 'TEACHER',
  SUPERVISOR: 'SUPERVISOR',
};

export const USER_TYPE = {
  JUNIOR: 'junior',
  SENIOR: 'senior',
  TEACHER: 'teacher',
  STAFF: 'staff',
};

// feature sets
export const FEATURE_SET = {
  EXTENDED: 'EXTENDED',
  STANDARD: 'STANDARD',
  EXTENDED_TEXTBOOK: 'EXTENDED_TEXTBOOK',
};

export const YEAR_LEVEL = {
  YEAR_7: '7',
  YEAR_8: '8',
  YEAR_9: '9',
  YEAR_10: '10',
  YEAR_11: '11',
  YEAR_12: '12',
  PARENT: 'P',
  TEACHER: 'T',
  OTHER: 'X',
};
